<template>

  <div>
    <div>
    <md-card>
      <md-card-header>
        <div class="md-title">Upload Store Master</div>
      </md-card-header>

      <md-card-content>

      </md-card-content>

      <md-card-actions>
        <calling-api path="/api/w/stores/special/action" :not-display-error="true">
          <md-button @click="exportStoreSpecialTemplate">Download Template</md-button>
          <md-button @click="toggleUploadStoreSpecial">Upload</md-button>
          <input type="file" class="md-hide" id="upload-store-special" accept=".xls,.xlsx" @change="handleUploadStoreSpecialFileSelected"/>
        </calling-api>
      </md-card-actions>
    </md-card>

    <md-card>
      <md-card-header>
        <div class="md-title">Upload Schedule</div>
      </md-card-header>

      <md-card-content>

      </md-card-content>

      <md-card-actions>
        <calling-api path="/api/w/schedules/save" :not-display-error="true">
          <md-button @click="exportSchdeuleTemplate">Download Template</md-button>
          <md-button @click="toggleUploadScheduke">Upload</md-button>
          <input type="file" class="md-hide" id="upload-schedule" accept=".xls,.xlsx" @change="handleUploadSchdeuleFileSelected"/>
        </calling-api>
      </md-card-actions>
    </md-card>
    </div>
    <hr class="solid">
    <div>
    <md-card>
      <md-card-header>
        <div class="md-title">Master Data</div>
      </md-card-header>

      <md-card-content>

      </md-card-content>

      <md-card-actions>
        <calling-api path="/api/w/masterData/update" :not-display-error="true">
          <md-button @click="exportMasterDataTemplate">Download Template</md-button>
          <md-button @click="toggleUploadMasterData">Upload</md-button>
          <input type="file" class="md-hide" id="upload-master-data" accept=".xls,.xlsx" @change="handleUploadMasterDataFileSelected"/>
        </calling-api>
      </md-card-actions>
    </md-card>

    <md-card>
      <md-card-header>
        <div class="md-title">Carrier Data</div>
      </md-card-header>

      <md-card-content>

      </md-card-content>

      <md-card-actions>
        <calling-api path="/api/w/masterData/update" :not-display-error="true">
          <md-button @click="exportCarrierDataTemplate">Download Template</md-button>
          <md-button @click="toggleUploadCarrierData">Upload</md-button>
          <input type="file" class="md-hide" id="upload-carrier-data" accept=".xls,.xlsx" @change="handleUploadCarrierDataFileSelected"/>
        </calling-api>
      </md-card-actions>
    </md-card>

    <md-card>
      <md-card-header>
        <div class="md-title">Location Data</div>
      </md-card-header>

      <md-card-content>

      </md-card-content>

      <md-card-actions>
        <calling-api path="/api/w/masterData/update" :not-display-error="true">
          <md-button @click="exportLocationDataTemplate">Download Template</md-button>
          <md-button @click="toggleUploadLocationData">Upload</md-button>
          <input type="file" class="md-hide" id="upload-location-data" accept=".xls,.xlsx" @change="handleUploadLocationDataFileSelected"/>
        </calling-api>
      </md-card-actions>
    </md-card>

    <md-card>
      <md-card-header>
        <div class="md-title">Route Data</div>
      </md-card-header>

      <md-card-content>

      </md-card-content>

      <md-card-actions>
        <calling-api path="/api/w/masterData/update" :not-display-error="true">
          <md-button @click="exportRouteDataTemplate">Download Template</md-button>
          <md-button @click="toggleUploadRouteData">Upload</md-button>
          <input type="file" class="md-hide" id="upload-route-data" accept=".xls,.xlsx" @change="handleUploadRouteDataFileSelected"/>
        </calling-api>
      </md-card-actions>
    </md-card>

    <md-card>
      <md-card-header>
        <div class="md-title">Chassis Data</div>
      </md-card-header>

      <md-card-content>

      </md-card-content>

      <md-card-actions>
        <calling-api path="/api/w/masterData/update" :not-display-error="true">
          <md-button @click="exportChassisDataTemplate">Download Template</md-button>
          <md-button @click="toggleUploadChassisData">Upload</md-button>
          <input type="file" class="md-hide" id="upload-chassis-data" accept=".xls,.xlsx" @change="handleUploadChassisDataFileSelected"/>
        </calling-api>
      </md-card-actions>
    </md-card>

    <md-card>
      <md-card-header>
        <div class="md-title">Leasing Chassis Data</div>
      </md-card-header>

      <md-card-content>

      </md-card-content>

      <md-card-actions>
        <calling-api path="/api/w/masterData/update" :not-display-error="true">
          <md-button @click="exportLeaseChassisDataTemplate">Download Template</md-button>
          <md-button @click="toggleUploadLeaseChassisData">Upload</md-button>
          <input type="file" class="md-hide" id="upload-leasechassis-data" accept=".xls,.xlsx" @change="handleUploadLeaseChassisDataFileSelected"/>
        </calling-api>
      </md-card-actions>
    </md-card>

    <md-card>
      <md-card-header>
        <div class="md-title">Customer Data</div>
      </md-card-header>

      <md-card-content>

      </md-card-content>

      <md-card-actions>
        <calling-api path="/api/w/masterData/update" :not-display-error="true">
          <md-button @click="exportCustomerDataTemplate">Download Template</md-button>
          <md-button @click="toggleUploadCustomerData">Upload</md-button>
          <input type="file" class="md-hide" id="upload-customer-data" accept=".xls,.xlsx" @change="handleUploadCustomerDataFileSelected"/>
        </calling-api>
      </md-card-actions>
    </md-card>

    <md-card>
      <md-card-header>
        <div class="md-title">Truck Data</div>
      </md-card-header>

      <md-card-content>

      </md-card-content>

      <md-card-actions>
        <calling-api path="/api/w/masterData/update" :not-display-error="true">
          <md-button @click="exportTruckDataTemplate">Download Template</md-button>
          <md-button @click="toggleUploadTruckData">Upload</md-button>
          <input type="file" class="md-hide" id="upload-truck-data" accept=".xls,.xlsx" @change="handleUploadTruckDataFileSelected"/>
        </calling-api>
      </md-card-actions>
    </md-card>

    </div>
  </div>

</template>

<style lang="scss" scoped>
  .md-card {
    width: 380px;
    margin: 8px;
    display: inline-block;
    vertical-align: top;
  }
  hr.solid {
    border-top: 3px solid #bbb;
    margin-top: 15px;
  }
    
  
</style>
<script>
  import parseXls from '../utils/parseXls';
  import dateFormat from '../utils/dateFormat';
  //import api from '../api';
  import { newAPIPost } from '../api';
  import { downloadExcel } from "../utils/excel";

  /* eslint-disable no-plusplus */

  const storeSpecialCols = [
    "storeId",
    "startDate",
    "endDate",
    "statusId",
    "driverRemark",
    "storeTimeFrom",
    "storeTimeTo",
    "dispatcherId",
    "haulierId",
    "driverGroup",
    "routeId",
    "endOutletIds",
    "defaultEndOutlet",
    "transloadingPoint",
    "days",
  ];

  const scheduleCols = [
    "storeId",
    "etaPlan",
    "etaAssigned",
    "driver",
  ];

  const masterDataCols = [
    "group",
    "tagId",
    "tagName",
    "parentGroup",
    "parentTagId",
  ];

  const carrierDataCols = [
    "group",
    "Carrier Id",
    "Carrier Name",
    "active",
    "scacode",
  ];

  const locationDataCols = [
    "group",
    "Location Id",
    "Location Name",
    "active",
    "street",
    "city",
    "state",
    "zip",
    "country",
    "contactperson",
    "contacttel",
  ];

  const routeDataCols = [
    "group",
    "Route Id",
    "Route Name",
    "active",
    "stage",
    "depPoint",
    "destPoint",
  ];

  const chassisDataCols = [
    "group",
    "Vendor Id",
    "Vendor Name",
    "vaildPerson",
    "saleoffice",
  ];
  
  const leasechassisDataCols = [
    "group",
    "Lease Chassis Id",
    "Lease Chassis Name",
    "active",
    "vendor",
    "equipsize",
  ];

  const customerDataCols = [
    "group",
    "Customer Id",
    "Customer Name",
    "active",
  ];

  const truckDataCols = [
    "group",
    "Truck Id",
    "Truck Name",
    "active",
    "saleoffice",
  ];

  export default {
    data: () => ({
      data: ["SheetJS".split(""), "1234567".split("")],
    }),

    methods: {
      exportStoreSpecialTemplate() {
        /* convert state to workbook */
        downloadExcel(
          [
            storeSpecialCols,
            [
              "3454",
              "2018-05-01",
              "2018-05-31",
              "ZS01",
              "Test",
              "09:00",
              "18:00",
              "Dis_Test",
              "5000310",
              "CA01",
              "R00001",
              "1010009,1010010",
              "1010009",
              "1010009",
              "1,2,3",
            ],
          ],
          'StoreMaster',
          'StoreMaster.xlsx',
        );
      },
      toggleUploadStoreSpecial() {
        this.$el.querySelector('#upload-store-special')
          .click();
      },
      handleUploadStoreSpecialFileSelected(e) {
        const { files } = e.target;
        if (files && files[0]) {
          parseXls(files[0])
            .then((data) => {
              const headCols = data[0];
              if (!_.isEqual(headCols, storeSpecialCols)) {
                window.alert('not a valid format');
                return;
              }

              headCols.push('upload result');

              data.shift();

              console.log(JSON.stringify(data));
              this.$el.querySelector('#upload-store-special').value = '';


              const allApiCalls = _(data)
                .chain()
                .map((it) => {
                  console.log(it);
                  console.log(it[2]);
                  let i = 0;
                  const storeSpecialDto = {
                    storeId: it[i++],
                    startDate: dateFormat.tryDateFromExcel(it[i++]),
                    endDate: dateFormat.tryDateFromExcel(it[i++]),
                    statusId: it[i++],
                    driverRemark: it[i++],
                    storeTimeFrom: it[i++],
                    storeTimeTo: it[i++],
                    dispatcherId: it[i++],
                    haulerId: it[i++],
                    driverGroup: it[i++],
                    routeId: it[i++],
                    endOutletIds: it[i++].split(','),
                    endOutletId: it[i++],
                    transloadingPoint: it[i++],
                    days: _(it[i++].split(","))
                      .map(d => parseInt(d, 0)),
                  };

                  return new Promise((resolve) => {
                    //api
                    //  .post(
                    newAPIPost(  
                        '/api/w/stores/special/action',
                        {
                          action: 'create',
                          storeSpecialDto,
                        },
                      )
                      .then(() => {
                        it.push('ok');
                        resolve(it);
                      })
                      .catch((err) => {
                        it.push(err.messages.join(';'));
                        resolve(it);
                      });
                  });
                })
                .value();

              Promise.all(allApiCalls)
                .then((results) => {
                  const resultData = [];
                  resultData.push(headCols);
                  _(results)
                    .each(it => resultData.push(it));

                  downloadExcel(
                    resultData,
                    'StoreMaster',
                    'StoreMaster-UploadResult.xlsx',
                  );
                });
            });
        }
      },
      exportSchdeuleTemplate() {
        /* convert state to workbook */
        downloadExcel(
          [
            scheduleCols,
            [
              "4100",
              "5/10/2018",
              "5/10/2018",
              "test",
            ],
          ],
          'FirstWeekSchedule',
          'FirstWeekSchedule.xlsx',
        );
      },
      toggleUploadScheduke() {
        this.$el.querySelector('#upload-schedule')
          .click();
      },
      handleUploadSchdeuleFileSelected(e) {
        const { files } = e.target;
        if (files && files[0]) {
          parseXls(files[0])
            .then((data) => {
              const headCols = data[0];
              if (!_.isEqual(headCols, scheduleCols)) {
                window.alert('not a valid format');
                return;
              }

              headCols.push('upload result');

              data.shift();

              console.log(JSON.stringify(data));
              this.$el.querySelector('#upload-schedule').value = '';

              const allApiCalls = _(data)
                .chain()
                .map((it) => {
                  let i = 0;
                  return new Promise((resolve) => {
                    //api
                    //  .post(
                    newAPIPost(  
                        '/api/w/schedules/save',
                        [
                          {
                            storeId: it[i++],
                            etaPlan: dateFormat.tryDateFromExcel(it[i++]),
                            etaAssigned: dateFormat.tryDateFromExcel(it[i++]),
                            driverId: it[i++],
                            action: 'FIRST_WEEK',
                          },
                        ],
                      )
                      .then(() => {
                        it.push('ok');
                        resolve(it);
                      })
                      .catch((err) => {
                        it.push(err.messages.join(';'));
                        resolve(it);
                      });
                  });
                })
                .value();

              Promise.all(allApiCalls)
                .then((results) => {
                  const resultData = [];
                  resultData.push(headCols);
                  _(results)
                    .each(it => resultData.push(it));

                  downloadExcel(
                    resultData,
                    'FirstWeekSchedule',
                    'FirstWeekSchedule-UploadResult.xlsx',
                  );
                });
            });
        }
      },
      exportMasterDataTemplate() {
        /* convert state to workbook */
        downloadExcel(
          [
            masterDataCols,
            [],
          ],
          'MasterData',
          'MasterData.xlsx',
        );
      },
      toggleUploadMasterData() {
        this.$el.querySelector('#upload-master-data')
          .click();
      },
      handleUploadMasterDataFileSelected(e) {
        const { files } = e.target;
        if (files && files[0]) {
          parseXls(files[0])
            .then((data) => {
              const headCols = data[0];
              if (!_.isEqual(headCols, masterDataCols)) {
                window.alert('not a valid format');
                return;
              }

              headCols.push('upload result');

              data.shift();

              console.log(JSON.stringify(data));
              this.$el.querySelector('#upload-master-data').value = '';

              const allApiCalls = _(data)
                .chain()
                .map((it) => {
                  while (it.length < masterDataCols.length) {
                    it.push(null);
                  }
                  let i = 0;
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(  
                      '/api/w/masterData/update',
                      {
                        group: it[i++],
                        tagId: it[i++],
                        tagName: it[i++],
                        parentGroup: it[i++],
                        parentTagId: it[i++],
                        active: true,
                      },
                    )
                      .then(() => {
                        it.push('ok');
                        resolve(it);
                      })
                      .catch((err) => {
                        it.push(err.messages.join(';'));
                        resolve(it);
                      });
                  });
                })
                .value();

              Promise.all(allApiCalls)
                .then((results) => {
                  const resultData = [];
                  resultData.push(headCols);
                  _(results)
                    .each(it => resultData.push(it));

                  downloadExcel(
                    resultData,
                    'MasterData',
                    'MasterData-UploadResult.xlsx',
                  );
                });
            });
        }
      },
      exportCarrierDataTemplate() {
        /* convert state to workbook */
        downloadExcel(
          [
            carrierDataCols,
            [],
          ],
          'CarrierData',
          'CarrierData.xlsx',
        );
      },
      toggleUploadCarrierData() {
        this.$el.querySelector('#upload-carrier-data')
          .click();
      },
      
      handleUploadCarrierDataFileSelected(e) {
      
        const { files } = e.target;
        if (files && files[0]) {
          parseXls(files[0])
            .then((data) => {
              const headCols = data[0];
              console.log("header",headCols);
              if (!_.isEqual(headCols, carrierDataCols)) {
                window.alert('not a valid format');
                return;
              }

              headCols.push('upload result');

              data.shift();

              console.log(JSON.stringify(data));
              this.$el.querySelector('#upload-carrier-data').value = '';

              const allApiCalls = _(data)
                .chain()
                .map((it) => {
                  while (it.length < carrierDataCols.length) {
                    it.push(null);
                  }
                  let i = 0;
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(  
                      '/api/w/masterData/update',
                      {
                        group: it[i++],
                        tagId: it[i++],
                        tagName: it[i++],
                        active: it[i++],
                        scacode: it[i++],
                      },
                    )
                      .then(() => {
                        it.push('ok');
                        resolve(it);
                      })
                      .catch((err) => {
                        it.push(err.messages.join(';'));
                        resolve(it);
                      });
                  });
                })
                .value();

              Promise.all(allApiCalls)
                .then((results) => {
                  const resultData = [];
                  resultData.push(headCols);
                  _(results)
                    .each(it => resultData.push(it));

                  downloadExcel(
                    resultData,
                    'CarrierData',
                    'CarrierData-UploadResult.xlsx',
                  );
                });
            });
        }
      },

      exportCustomerDataTemplate() {
        /* convert state to workbook */
        downloadExcel(
          [
            customerDataCols,
            [],
          ],
          'CustomerData',
          'CustomerData.xlsx',
        );
      },
      toggleUploadCustomerData() {
        this.$el.querySelector('#upload-customer-data')
          .click();
      },
      
      handleUploadCustomerDataFileSelected(e) {
      
        const { files } = e.target;
        if (files && files[0]) {
          parseXls(files[0])
            .then((data) => {
              const headCols = data[0];
              console.log("header",headCols);
              if (!_.isEqual(headCols, customerDataCols)) {
                window.alert('not a valid format');
                return;
              }

              headCols.push('upload result');

              data.shift();

              console.log(JSON.stringify(data));
              this.$el.querySelector('#upload-customer-data').value = '';

              const allApiCalls = _(data)
                .chain()
                .map((it) => {
                  while (it.length < customerDataCols.length) {
                    it.push(null);
                  }
                  let i = 0;
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(  
                      '/api/w/masterData/update',
                      {
                        group: it[i++],
                        tagId: it[i++],
                        tagName: it[i++],
                        active: true,
                      },
                    )
                      .then(() => {
                        it.push('ok');
                        resolve(it);
                      })
                      .catch((err) => {
                        it.push(err.messages.join(';'));
                        resolve(it);
                      });
                  });
                })
                .value();

              Promise.all(allApiCalls)
                .then((results) => {
                  const resultData = [];
                  resultData.push(headCols);
                  _(results)
                    .each(it => resultData.push(it));

                  downloadExcel(
                    resultData,
                    'CustomerData',
                    'CustomerData-UploadResult.xlsx',
                  );
                });
            });
        }
      },

      exportTruckDataTemplate() {
        /* convert state to workbook */
        downloadExcel(
          [
            truckDataCols,
            [],
          ],
          'TruckData',
          'TruckData.xlsx',
        );
      },
      toggleUploadTruckData() {
        this.$el.querySelector('#upload-truck-data')
          .click();
      },
      
      handleUploadTruckDataFileSelected(e) {
      
        const { files } = e.target;
        if (files && files[0]) {
          parseXls(files[0])
            .then((data) => {
              const headCols = data[0];
              console.log("header",headCols);
              if (!_.isEqual(headCols, truckDataCols)) {
                window.alert('not a valid format');
                return;
              }

              headCols.push('upload result');

              data.shift();

              console.log(JSON.stringify(data));
              this.$el.querySelector('#upload-truck-data').value = '';

              const allApiCalls = _(data)
                .chain()
                .map((it) => {
                  while (it.length < truckDataCols.length) {
                    it.push(null);
                  }
                  let i = 0;
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(  
                      '/api/w/masterData/update',
                      {
                        group: it[i++],
                        tagId: it[i++],
                        tagName: it[i++],
                        saleoffice: it[i++],
                        active: true,
                      },
                    )
                      .then(() => {
                        it.push('ok');
                        resolve(it);
                      })
                      .catch((err) => {
                        it.push(err.messages.join(';'));
                        resolve(it);
                      });
                  });
                })
                .value();

              Promise.all(allApiCalls)
                .then((results) => {
                  const resultData = [];
                  resultData.push(headCols);
                  _(results)
                    .each(it => resultData.push(it));

                  downloadExcel(
                    resultData,
                    'TruckData',
                    'TruckData-UploadResult.xlsx',
                  );
                });
            });
        }
      },

      exportChassisDataTemplate() {
        /* convert state to workbook */
        downloadExcel(
          [
            chassisDataCols,
            [],
          ],
          'ChassisData',
          'ChassisData.xlsx',
        );
      },
      toggleUploadChassisData() {
        this.$el.querySelector('#upload-chassis-data')
          .click();
      },
      
      handleUploadChassisDataFileSelected(e) {
      
        const { files } = e.target;
        if (files && files[0]) {
          parseXls(files[0])
            .then((data) => {
              const headCols = data[0];
              console.log("header",headCols);
              if (!_.isEqual(headCols, chassisDataCols)) {
                window.alert('not a valid format');
                return;
              }

              headCols.push('upload result');

              data.shift();

              console.log(JSON.stringify(data));
              this.$el.querySelector('#upload-chassis-data').value = '';

              const allApiCalls = _(data)
                .chain()
                .map((it) => {
                  while (it.length < chassisDataCols.length) {
                    it.push(null);
                  }
                  let i = 0;
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(  
                      '/api/w/masterData/update',
                      {
                        group: it[i++],
                        tagId: it[i++],
                        tagName: it[i++],
                        validPeriod: it[i++],
                        saleoffice: it[i++],
                      },
                    )
                      .then(() => {
                        it.push('ok');
                        resolve(it);
                      })
                      .catch((err) => {
                        it.push(err.messages.join(';'));
                        resolve(it);
                      });
                  });
                })
                .value();

              Promise.all(allApiCalls)
                .then((results) => {
                  const resultData = [];
                  resultData.push(headCols);
                  _(results)
                    .each(it => resultData.push(it));

                  downloadExcel(
                    resultData,
                    'ChassisData',
                    'ChassisData-UploadResult.xlsx',
                  );
                });
            });
        }
      },

      exportLeaseChassisDataTemplate() {
        /* convert state to workbook */
        downloadExcel(
          [
            leasechassisDataCols,
            [],
          ],
          'LeasechassisData',
          'LeasechassisData.xlsx',
        );
      },
      toggleUploadLeaseChassisData() {
        this.$el.querySelector('#upload-leasechassis-data')
          .click();
      },
      
      handleUploadLeaseChassisDataFileSelected(e) {
      
        const { files } = e.target;
        if (files && files[0]) {
          parseXls(files[0])
            .then((data) => {
              const headCols = data[0];
              console.log("header",headCols);
              if (!_.isEqual(headCols, leasechassisDataCols)) {
                window.alert('not a valid format');
                return;
              }

              headCols.push('upload result');

              data.shift();

              console.log(JSON.stringify(data));
              this.$el.querySelector('#upload-leasechassis-data').value = '';

              const allApiCalls = _(data)
                .chain()
                .map((it) => {
                  while (it.length < leasechassisDataCols.length) {
                    it.push(null);
                  }
                  let i = 0;
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(  
                      '/api/w/masterData/update',
                      {
                        group: it[i++],
                        tagId: it[i++],
                        tagName: it[i++],
                        active: it[i++],
                        vendor: it[i++],
                        equipsize: it[i++],
                      },
                    )
                      .then(() => {
                        it.push('ok');
                        resolve(it);
                      })
                      .catch((err) => {
                        it.push(err.messages.join(';'));
                        resolve(it);
                      });
                  });
                })
                .value();

              Promise.all(allApiCalls)
                .then((results) => {
                  const resultData = [];
                  resultData.push(headCols);
                  _(results)
                    .each(it => resultData.push(it));

                  downloadExcel(
                    resultData,
                    'LeasechassisData',
                    'LeasechassisData-UploadResult.xlsx',
                  );
                });
            });
        }
      },

      exportLocationDataTemplate() {
        /* convert state to workbook */
        downloadExcel(
          [
            locationDataCols,
            [],
          ],
          'LocationData',
          'LocationData.xlsx',
        );
      },
      toggleUploadLocationData() {
        this.$el.querySelector('#upload-location-data')
          .click();
      },
      handleUploadLocationDataFileSelected(e) {
        const { files } = e.target;
        if (files && files[0]) {
          parseXls(files[0])
            .then((data) => {
              const headCols = data[0];
              if (!_.isEqual(headCols, locationDataCols)) {
                window.alert('not a valid format');
                return;
              }

              headCols.push('upload result');

              data.shift();

              console.log(JSON.stringify(data));
              this.$el.querySelector('#upload-location-data').value = '';

              const allApiCalls = _(data)
                .chain()
                .map((it) => {
                  while (it.length < locationDataCols.length) {
                    it.push(null);
                  }
                  let i = 0;
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(  
                      '/api/w/masterData/update',
                      {
                        group: it[i++],
                        tagId: it[i++],
                        tagName: it[i++],
                        street: it[i++],
                        city: it[i++],
                        state: it[i++],
                        zip: it[i++],
                        country: it[i++],
                        contactPerson: it[i++],
                        contactTel: it[i++],
                        active: true,
                      },
                    )
                      .then(() => {
                        it.push('ok');
                        resolve(it);
                      })
                      .catch((err) => {
                        it.push(err.messages.join(';'));
                        resolve(it);
                      });
                  });
                })
                .value();

              Promise.all(allApiCalls)
                .then((results) => {
                  const resultData = [];
                  resultData.push(headCols);
                  _(results)
                    .each(it => resultData.push(it));

                  downloadExcel(
                    resultData,
                    'LocationData',
                    'LocationData-UploadResult.xlsx',
                  );
                });
            });
        }
      },

      exportRouteDataTemplate() {
        /* convert state to workbook */
        downloadExcel(
          [
            routeDataCols,
            [],
          ],
          'RouteData',
          'RouteData.xlsx',
        );
      },
      toggleUploadRouteData() {
        this.$el.querySelector('#upload-route-data')
          .click();
      },
      handleUploadRouteDataFileSelected(e) {
        const { files } = e.target;
        if (files && files[0]) {
          parseXls(files[0])
            .then((data) => {
              const headCols = data[0];
              if (!_.isEqual(headCols, routeDataCols)) {
                window.alert('not a valid format');
                return;
              }

              headCols.push('upload result');

              data.shift();

              console.log(JSON.stringify(data));
              this.$el.querySelector('#upload-route-data').value = '';

              const allApiCalls = _(data)
                .chain()
                .map((it) => {
                  while (it.length < routeDataCols.length) {
                    it.push(null);
                  }
                  let i = 0;
                  return new Promise((resolve) => {
                    //api.post(
                    newAPIPost(  
                      '/api/w/masterData/update',
                      {
                        group: it[i++],
                        tagId: it[i++],
                        tagName: it[i++],
                        stage: it[i++],
                        deptPoint: it[i++],
                        destPoint: it[i++],
                        active: true,
                      },
                    )
                      .then(() => {
                        it.push('ok');
                        resolve(it);
                      })
                      .catch((err) => {
                        it.push(err.messages.join(';'));
                        resolve(it);
                      });
                  });
                })
                .value();

              Promise.all(allApiCalls)
                .then((results) => {
                  const resultData = [];
                  resultData.push(headCols);
                  _(results)
                    .each(it => resultData.push(it));

                  downloadExcel(
                    resultData,
                    'RouteData',
                    'RouteData-UploadResult.xlsx',
                  );
                });
            });
        }
      },

    },
  };

</script>
